import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { TableCellBase, TableCellText, TableEmptyCell } from '../../Table'
import { UserMultiValue } from '../../User'

import {
  checkIsWaitingOnUserMasked,
  toWaitingOnUserValue,
} from './RentalPortalWaitingOnCell.utils'

import * as styles from './RentalPortalWaitingOnCell.module.css'

import LockIcon from '../../../icons/lock.svg'

function RentalPortalWaitingOnCell({ attention = EMPTY_OBJECT, ...cellProps }) {
  const { t } = useTranslation()

  const { needs_you: needsYou, waiting_on: waitingOn } = attention

  return waitingOn?.label ? (
    <TableCellBase {...cellProps} className={styles.RentalPortalWaitingOnCell}>
      {needsYou ? <span className={styles.marker} /> : null}
      {waitingOn.user ? (
        <UserMultiValue
          {...toWaitingOnUserValue(waitingOn.user)}
          {...(checkIsWaitingOnUserMasked(waitingOn.user)
            ? { Icon: LockIcon }
            : null)}
          className={styles.user}
        />
      ) : (
        <TableCellText value={t(waitingOn.label)} />
      )}
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} />
  )
}

export default RentalPortalWaitingOnCell
